import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {BsChatLeftText} from "react-icons/bs";
import {AES} from "crypto-js";
import {useStateValue} from "../../../states/StateProvider";
import {formatDate} from "../../../helper/formatDate";

const FirmenprojekteView = ({FirmaKurz,ZustBerater,Bank,RegioBereich,FBKBank,MA,PStatus,Note, printing, date, FirmaID, portal, vertrieb, WV}) => {

    String.prototype.allReplace = function(obj) {
        let retStr = this;
        for (const x in obj) {
            retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
        }
        return retStr;
    };

    const [{secretKey}] = useStateValue();

    const getStatusClasses = () => {
        // Always use PStatus for determining row styling (both RUV and DGG portals)
        const status = PStatus?.trim().toLowerCase();

        if (status === 'projekt absage') {
            return 'bg-borderRed border-whiteDarker';
        }
        if (status === '13 projekt abschluss' || status === '18 projekt abschluss') {
            return 'bg-complete border-whiteDark';
        }
        return '';
    };

    return (
        <tr className={`border-y border-silver border-x-0 text-sm ${getStatusClasses()}`}>
            <td className="w-40 text-sm text-mainBlue underline font-light pr-3">
                <Link
                    to={{
                        pathname: `/firmenprojekte/${portal}/${FirmaID}`,
                    }}
                    target='_blank'
                >
                    {FirmaKurz}
                </Link>
            </td>
            <td className={`${portal==='dgg'? 'w-72': 'w-40'} text-gray-900 font-light pr-3`}>
                {ZustBerater}
            </td>
            <td className={`${portal==='dgg'? 'w-16': 'w-40'} text-gray-900 font-light pr-3`}>
                {Bank}
            </td>
            <td className="w-40 text-gray-900 font-light pr-3">
                {RegioBereich}
            </td>
            <td className="w-40 text-gray-900 font-light pr-3 ">
                {FBKBank}
            </td>
            <td className="w-16 text-gray-900 font-light pr-3">
                {MA}
            </td>
            {portal==='dgg' ?
            <td className="w-16 text-gray-900 font-light pr-3">
                {vertrieb}
            </td>
                : '' }
            <td className="w-40 text-gray-900 font-light pr-3 ">
                {PStatus}
            </td>
            <td className="w-24 font-light text-gray-900 pr-3">
                {date || ''}
            </td>
            <td className="w-24 font-light text-gray-900 pr-3">
                {WV ? formatDate(WV, false) : ''}
            </td>
            <td hidden={printing} className="w-16 tooltip text-gray-900 font-light pr-3">
                { (Note || WV) ? <BsChatLeftText size='16px'/> : '' }
                <span className={`${Note ? 'tooltiptext' : 'hidden'}`}>
                    {Note}
                </span>
            </td>
        </tr>
    )
}

export default FirmenprojekteView
